<template>
  <div class="login-page">

    <!-- ⬜ White login box -->
    <div class="login-box">
      <h2>Login</h2>

      <div class="alert alert-danger" v-if="showError"> <span>Unable to verify information. Please try again</span> </div>

      <div class="form-group">
        <input
          type="text"
          class="form-control"
          placeholder="Order Number"
          v-model="v$.tracerNumber.$model"
        />
        <span
          v-if="v$.tracerNumber.$dirty && v$.tracerNumber.required.$invalid"
          class="text-danger fst-italic smaller-85"
        >
          Required
        </span>
      </div>

      <div class="form-group margin-top-20">
        <input
          type="text"
          class="form-control"
          placeholder="Zip Code"
          v-model="v$.zipCode.$model"
          v-maska="'#####'"
        />
        <span
          v-if="v$.zipCode.$dirty && v$.zipCode.required.$invalid"
          class="text-danger fst-italic smaller-85"
        >
          Required
        </span>
      </div>

      <div class="form-group margin-top-20">
        <button
          class="default-btn w-100"
          :disabled="buttonDisabled"
          @click="login"
        >
          Sign In
        </button>
      </div>
    </div>

    <!-- 🔴 Error block OUTSIDE the white box -->
    <div
      v-if="showErrorBlock && formattedErrorMessage && formattedErrorMessage.length > 0"
      class="row justify-content-center margin-top-30 login-msg"
    >
      <div >
        <div class="p-4 border rounded bg-light">
          <h4 class="mb-3 fw-semibold">Important Information</h4>

          <p
            v-for="(line, index) in formattedErrorMessage"
            :key="index"
            class="mb-2 text-dark"
          >
            {{ line }}
          </p>
        </div>
      </div>
    </div>

  </div>
</template>



<script>
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import axios from "axios";

export default {
  name: "login-app",

  setup() {
    return {
      v$: useVuelidate()
    };
  },

  data() {
    return {
      tracerNumber: null,
      zipCode: null,
      showError: false,
      failedLoginMessage:""
    };
  },

  validations() {
    return {
      tracerNumber: { required },
      zipCode: { required }
    };
  },

  computed: {
    buttonDisabled() {
      return this.v$.$invalid;
    },

    showErrorBlock() {
      return this.showError || this.reason === "login_failed";
    },

    reason() {
      const params = new URLSearchParams(window.location.search);
      return params.get("reason");
    },

    formattedErrorMessage() {
      return this.failedLoginMessage
        .split(/\r?\n/)
        .filter(line => line.trim() !== "");
    }
  },

mounted() {
  this.$nextTick(() => {
    this.tracerNumber = window.baseVariables.tracerNumber;

    if (this.reason === "login_failed") {
      this.loadFailedLoginMessage();
    }
  });
},

  methods: {

      async loadFailedLoginMessage() {
    try {
      const res = await axios.get(
        "/api/ConfigApi/failed-login-message"
      );
      // assuming API returns plain text
      this.failedLoginMessage = res.data || "";
    } catch {
      // fallback message if API fails
      this.failedLoginMessage =
        "Unable to verify your information at this time. Please try again later.";
    }
  },
    async login() {
      const model = {
        tracerNumber: this.tracerNumber,
        zipCode: this.zipCode
      };

      try {
        const result = await axios.post(
          window.appUrls.loginApiLogin,
          model
        );

        if (result.status === 200 && result.data.isSuccess) {
          window.location = result.data.url;
        } else {
          this.showError = true;
            await this.loadFailedLoginMessage();
        }
      } catch {
        this.showError = true;
          await this.loadFailedLoginMessage();
      }
    }
  }
};
</script>


<style scoped>
.default-btn:disabled,
.default-btn[disabled] {
  opacity: 0.5;
}

.margin-top-30 {
  margin-top: 30px;
}

.login-page {
  margin: 0 auto;
}

.login-box {
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.08);
  max-width: 500px;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
}

.login-msg{
  margin-top: 30px;
    max-width: 650px;
    margin-left: auto;
    margin-right: auto;
}
</style>